<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <div class="page-heading">
      <div class="container">
        <div class="heading-content">
          <h1>华胤新能源</h1>
        </div>
      </div>
    </div>
    <div class="xnyNum">
      <div class="xnytitle">NO.1 国盛电站</div>
      <div>
        <carousel-3d
          :controlsVisible="true"
          :width="cWidth"
          :height="cHeight"
          :display="5"
          :space="280"
        >
          <slide :index="0">
            <img v-lazy="hyxny1" style="width: 100%; height: 100%" alt="" />
          </slide>
          <slide :index="1">
            <img v-lazy="hyxny2" style="width: 100%; height: 100%" alt="" />
          </slide>
          <slide :index="2">
            <img v-lazy="hyxny3" style="width: 100%; height: 100%" alt="" />
          </slide>
          <slide :index="3">
            <img v-lazy="hyxny4" style="width: 100%; height: 100%" alt="" />
          </slide>
          <slide :index="4">
            <img v-lazy="hyxny5" style="width: 100%; height: 100%" alt="" />
          </slide>
        </carousel-3d>
      </div>
      <div class="xnyContent">
        <p>
          分布式光伏发电特指在用户场地附近建设，运行方式以用户侧自发自用、余电上网，且在配电系统平衡调节为特征的光伏发电设施。
          采用光伏组件，将太阳能直接转换为电能的分布式发电系统。就近发电，就近并网，就近转换，就近使用，有效提高同等规模光伏电站的发电量，还有效解决了电力在升压及长途运输中的损耗。
          应用最为广泛的分布式光伏发电系统，是建在城市建筑物屋顶的光伏发电项目。该类项目必须接入公共电网，与公共电网一起为附近的用户供电。
        </p>
      </div>
    </div>
    <div class="xnyNum">
      <div class="xnytitle">NO.2 森钢电站</div>
      <div>
        <carousel-3d
          :controlsVisible="true"
          :width="cWidth"
          :height="cHeight"
          :display="5"
          :space="280"
        >
          <slide :index="0">
            <img v-lazy="hyxny6" style="width: 100%; height: 100%" alt="" />
          </slide>
          <slide :index="1">
            <img v-lazy="hyxny7" style="width: 100%; height: 100%" alt="" />
          </slide>
          <slide :index="2">
            <img v-lazy="hyxny8" style="width: 100%; height: 100%" alt="" />
          </slide>
          <slide :index="3">
            <img v-lazy="hyxny9" style="width: 100%; height: 100%" alt="" />
          </slide>
          <slide :index="4">
            <img v-lazy="hyxny10" style="width: 100%; height: 100%" alt="" />
          </slide>
        </carousel-3d>
      </div>
      <div class="xnyContent">
        <p>
          该光伏电站项目由宣城森钢太阳能科技有限公司投资建设，利用安徽森钢装配制造有限公司屋顶，主要安装区域为车间屋顶，屋面为彩钢瓦屋面，采用575Wp单晶硅组件3478块，总装机容量为2000kWp屋顶光伏发电项目，消纳方式为自发自用，余电上网，并网电压为380V。
        </p>
        <p>
          本项目拟选用低压380V接入方案，总装机容量为2000kW，光伏逆变器根据屋顶装机将容量不同，采用575kW组串式逆变器16台，共计使用16台逆变器，新增4台光伏并网柜。铺设在屋面上的光伏组件经组串式逆变器完成直流-交流转换后沿原有强电井及地下电缆沟敷设10根电缆至用户变内新增的“并网柜”，本项目合计4个并网点。经测算，分布式光伏发电项目第1年预计发电量约为204.9万kW•h。25年总发电量预计4715万kW•h。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hyxny1: require('@/components/img/hyxny/xny1.png'),
      hyxny2: require('@/components/img/hyxny/xny2.png'),
      hyxny3: require('@/components/img/hyxny/xny3.png'),
      hyxny4: require('@/components/img/hyxny/xny4.png'),
      hyxny5: require('@/components/img/hyxny/xny5.png'),
      hyxny6: require('@/components/img/hyxny/xny6.png'),
      hyxny7: require('@/components/img/hyxny/xny7.png'),
      hyxny8: require('@/components/img/hyxny/xny8.png'),
      hyxny9: require('@/components/img/hyxny/xny9.png'),
      hyxny10: require('@/components/img/hyxny/xny10.png'),
    }
  },
  mounted() {
    // 获取高度
    window.onresize = () => {
      this.changeHeight()
    }
  },
  methods: {
    changeHeight() {
      if (document.body.clientWidth >= 2000) {
        this.cWidth = 1300
        this.cHeight = 700
      } else if (document.body.clientWidth >= 768) {
        this.cWidth = 900
        this.cHeight = 400
      } else if (document.body.clientWidth < 768) {
        this.cWidth = 1000
        this.cHeight = 400
      }
    },
  },
  created() {
    this.changeHeight()
  },
}
</script>

<style scoped>
/* 头部 */
.page-heading {
  background-image: url(@/components/img/hyxny/one4.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  width: 100%;
  text-align: center;
}

.page-heading .heading-content h1 {
  font-size: 32px;
  text-transform: uppercase;
  color: #fff;
  letter-spacing: 1px;
  background-color: rgba(5, 5, 5, 0.9);
  display: inline-block;
  margin-bottom: 0;
  margin-top: 220px;
  padding: 20px 60px;
}

.page-heading .heading-content em {
  font-style: normal;
  font-weight: 200;
}

.xnytitle {
  font-size: 60px; /*设置文字大小*/
  color: #000; /*设置文字颜色*/
  text-shadow: 0 8px 10px #555; /*设置文字阴影*/
  font-weight: bolder; /*设置文字宽度*/
  text-align: center; /*设置文字居中*/
}
/* 内容 */
.xnyNum {
  margin: 20px;
  padding: 20px;
  border: 1px solid black;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
.xnyContent {
  margin: 10px;
  font-size: 20px;
  max-width: 100%;
  word-wrap: break-word;
  word-break: break-all;
}
@media (max-width: 768px) {
  .xnytitle {
    font-size: 32px;
  }
  .xnyContent {
    font-size: 15px;
    margin: 0;
  }
}
@media screen and (min-width: 2000px) {
  .page-heading .heading-content h1 {
    font-size: 40px;
  }
  .xnyContent {
    margin: 30px;
    font-size: 22px;
  }
}
</style>
